<template>
  <div class="component-top">
    <div class="component-top-container">
      <div class="item item-brand">
        <!-- <symbol v-show="isRoot" name="logo" v-link="{ path: '/', exact: true}"></symbol>-->
        <img class="mindsocial-logo" src="https://mindsocial.dk/wp-content/uploads/2019/10/MindSocial-logo-icon-dark-blue.png">
        <back-button v-if="!isRoot" @click="back">Back</back-button>
      </div>
      <div class="item item-main">
        <small-heading>{{title}}</small-heading>
      </div>
      <div class="item item-right">
        <!-- <avatar :email="email" size="66" v-link="{name: 'login'}"></avatar>-->
      </div>
    </div>
  </div>
</template>


<script>
import Symbol from './Symbol.vue'
import Logo from './SmallLogo.vue'
import BackButton from './BackButton.vue'
import SmallHeading from './SmallHeading.vue'
import Avatar from './Avatar.vue'
import { backRoute } from '../vuex/view/getters'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: 'jakobhenner@gmail.com'
    }
  },
  computed: {
    isRoot () {
      return this.$route.name === 'root' || this.$route.name === 'login'
    }
  },
  components: {
    Symbol,
    Logo,
    BackButton,
    SmallHeading,
    Avatar
  },
  methods: {
    checkRoute () {
    },
    back () {
      this.$route.router.go(window.history.back())
    }
  },
  watch: {
    '$route': 'checkRoute'
  },
  vuex: {
    getters: {
      backRoute
    }
  },
  ready () {
    this.checkRoute()
  }
}
</script>


<style lang="scss" scoped>
@import 'src/scss/basis/variables';

.component-top {
  &-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: $z-index-header;
  }
  .item {
    display: flex;
    align-items: center;
    position: relative;

    &-main {
      flex: 1;
      justify-content: center;
    }

    &:last-child {
      margin-right: 0rem;
    }
  }
}
.small-logo {
  margin-left: 1rem;
}
.mindsocial-logo {
  width: 60px;
  margin-left: 1rem;

}
</style>



// WEBPACK FOOTER //
// Top.vue?4901898e